import { render, staticRenderFns } from "./humanResources.vue?vue&type=template&id=61590272&scoped=true"
import script from "./humanResources.vue?vue&type=script&lang=js"
export * from "./humanResources.vue?vue&type=script&lang=js"
import style0 from "./humanResources.vue?vue&type=style&index=0&id=61590272&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61590272",
  null
  
)

export default component.exports